module.exports = __webpack_public_path__ + "img/crypto-seed-phrase-storage_B096J2VXTS.157ee8e4.jpg";